import { template, mapStateToProps, mapActionsToProps } from '@banking/ui/components/banking/activity/connected-page';
import { workflowComponent } from '@banking/ui/services/savings-reporter';
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);